import { Button } from "primereact/button";
import ContactUsSection from "../Components/contactUsSection";

const HealthcareProviders = () => {
    const features = [
        {
            src: "/PatientMonitoring.png",
            title: "Smart Patient Monitoring",
            desc: "Keep track of every patient with ease. Monitor adherence, exercise quality, and outcomes with real-time dashboards and auto-generated reports, without extra work."
        },
        {
            src: "/Time.png",
            title: "Save Time, See More Patients",
            desc: "Automate what slows you down. Mobithera reduces manual tasks with AI-based tracking and reporting, freeing up your time for higher-value clinical care."
        },
        {
            src: "/Remotely.png",
            title: "Support Your Patients Remotely",
            desc: "Assign, monitor, and update therapy plans remotely. Stay connected and in control, even between in-person visits."
        }
    ]
    return (
        <>
        <div style={{
                width: "100%",
                backgroundImage: "url('/HealthcareProviders.jpg')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "right",
                position: "relative",
            }} className="flex flex-column justify-content-center gap-5 px-4 md:px-8 py-8" >
                <p className="m-0 text-left" style={{ color: "#29345E", lineHeight: "4rem", fontSize: "3.25rem", fontWeight: 700, wordBreak: "break-word" }} >
                    Smarter <br /> Rehabilitation For <br /> Leading Clinics
                </p>
                <p className="m-0 text-xl text-left" style={{ color: "#727A99"}}>
                    Powered by AI, mobithera offers an innovative <br />
                    approach that simplifies clinical workflows, <br />
                    reduces workload, and enables professionals <br />
                    to treat more patients efficiently.
                </p>
                <Button label="Get in touch" iconPos="right"
                    icon="pi pi-angle-right"
                    className="text-lg"
                    style={{
                        color: "white",
                        fontWeight: 700,
                        backgroundColor: "#E3506B",
                        borderRadius: "10px",
                        height: "3.5rem",
                        width: "15rem"
                    }} />
            </div>
            <div style={{
                width: "100%",
                minHeight: "100vh",
                backgroundImage: "url('/RequestDemoBackground.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
            }} className="flex flex-column justify-content-center align-items-center gap-2 px-4 md:px-8 py-8" >
                <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >FEATURES</p>
                <p className="flex flex-wrap justify-content-center align-items-center m-0 text-center mb-6" style={{ color: "white", fontSize: "3.25rem", lineHeight: "4.5rem", fontWeight: 700, wordBreak: "break-word" }}>
                    Why <span className="flex mx-3 align-items-center gap-1" style={{color: "#E3506B"}}>Mobithera<span style={{fontSize: "1.25rem", marginTop: "-0.5rem"}}>™</span></span> is Chosen by Leading Clinics
                </p>
                <p className="text-xl m-0 text-center" style={{color: "#EAEBF0"}}>
                    Digital tools designed to simplify patient management and enhance clinical <br />
                    decision-making remotely or in person.
                </p>
                <div className="flex flex-wrap gap-5 justify-content-center xl:justify-content-between py-8" style={{ width: "100%" }}>
                    {features.map((feature) => (
                        <div className="flex flex-grow-1 flex-column bg-white justify-content-center align-items-center gap-4 px-4 py-8" style={{ width: "25rem" }}>
                            <img src={feature.src} alt={feature.title} key={feature.title} width={30} />
                            <p className="m-0 text-center font-bold" style={{ color: "#2D3967", fontSize: "1.25rem"}}>
                                {feature.title}
                            </p>
                            <p className="m-0 text-center text-lg" style={{ color: "#727A99"}}>
                                {feature.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
            {/*  Goals */}
            <div className="flex flex-wrap justify-content-between align-items-center gap-8 px-4 md:px-8 py-8" style={{backgroundColor: "#F5F5F5"}}>
                <div className="flex flex-column justify-content-center align-items-start gap-4 flex-grow-1 xl:w-30rem" >
                    <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >GOALS</p>
                    <p className="m-0" style={{ color: "#2D3967", fontSize: "3.25rem", fontWeight: 700 }} >
                        Manage Your Patients in One Platform
                    </p>
                    <p className="m-0 text-xl" style={{ color: "#727A99" }}>
                        Mobithera gives you a clear, centralized
                        view of each patient’s therapy journey
                        including key metrics, adherence, and
                        progress.

                        <ul>
                            <li className="m-0">Monitor exercise quality and compliance</li>
                            <li className="m-0">Access real-time dashboards</li>
                            <li className="m-0">Save time with organized records</li>
                        </ul>
                    </p>
                </div>
                <img src="/Goals-1-1.png" className="w-12 sm:w-30rem sm:flex-grow-1" style={{ objectFit: "cover"  }} />
            </div>
            {/*  Goals - 2 */}
            <div className="flex flex-wrap justify-content-between align-items-center gap-8 px-4 md:px-8 py-8 " style={{backgroundColor: "#F5F5F5"}}>
                <img src="/Goals-1-2.png" className="w-12 sm:w-30rem sm:flex-grow-1" style={{ objectFit: "cover"  }} />
                <div className="flex flex-grow-1 flex-column justify-content-center align-items-start gap-4 xl:w-30rem" >
                    <p className="m-0 text-xl" style={{ color: "#BEC2D0", letterSpacing: "4px" }} >GOALS</p>
                    <p className="m-0" style={{ color: "#2D3967", fontSize: "3.25rem", fontWeight: 700, wordBreak: "break-word" }} >
                        Create Detailed, Personalized Prescriptions
                    </p>
                    <p className="m-0 text-xl" style={{ color: "#727A99" }}>
                        Create and assign personalized exercise
                        plans based on each patient’s condition and
                        recovery stage. Mobithera makes every
                        program clear, adaptable, and results-driven.

                        <ul>
                            <li className="m-0">Customize sets, reps, and time</li>
                            <li className="m-0">Choose from 2000+ AI-guided exercises</li>
                            <li className="m-0">Easily assign and track digitally</li>
                        </ul>
                    </p>
                </div>
            </div>
            {/*  Applications */}
            <ContactUsSection />
        </>
    )
}

export default HealthcareProviders;